<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { defineProps, defineEmits, reactive, ref, onMounted, computed } from "vue";

    const defaultClassesList = "justify-content-center";
    const emit = defineEmits(["click"])
    const props = defineProps<{
        type?: 'button' | 'submit' | 'reset',
        loading?: boolean,
        disabled?: boolean,
        classesList?: string,
        id?: string
    }>();
    const computedClassesList = computed(() => {
        let classes = defaultClassesList;
        if (props.classesList) { classes = `${classes} ${props.classesList}`; }
        return classes;
    });
    const computedType = computed(() => props.type ?? "button");
</script>
<template>
    <!-- sm tips color2 light white white2 success info warning danger -->
    <button :id="props.id" :type="computedType" :class="[ computedClassesList, props.loading ? 'loading' : '']" :disabled="props.loading || props.disabled" @click="emit('click')">
        <div class="btn-show" :class="{'display-none': props.loading}">
            <slot>Button</slot>
        </div>
        <div class="btn-loading" :class="{'display-none': !props.loading}">
            <div class="loader-dots"></div> 
        </div>
    </button>
</template>